<template>
  <v-toolbar
    absolute
    bottom
    dense
    class="bg-with-transparency pb-3 elevation-0"
    flat
  >
    <v-btn
      icon
      absolute
      right
      :disabled="disablePrev"
      color="primary"
      style="left: 15px; bottom: 3px"
      @click="previous()"
    >
      <v-icon>mdi-arrow-left-bold-circle</v-icon>
    </v-btn>
    <v-spacer />
    <div>
      <div class="body-1 text-center">
        {{ title }}
      </div>
      <div
        class="subheading text-center"
        @click="openChapterInfo()"
      >
        {{ currentContent.title }}
      </div>
    </div>
    <v-spacer />
    <v-btn
      icon
      absolute
      right
      :disabled="disableNext"
      color="primary"
      style="right: 15px; bottom: 3px"
      @click="next()"
    >
      <v-icon>mdi-arrow-right-bold-circle</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    currentContent: {
      type: Object,
      default: () => {},
    },
    disablePrev: {
      type: Boolean,
    },
    disableNext: {
      type: Boolean,
    },
  },
  methods: {
    previous() {
      this.$emit('previous');
    },
    next() {
      this.$emit('next');
    },
    openChapterInfo() {
      this.$emit('openChapterInfo');
    },
  },
};
</script>
<style lang="scss" scoped>
#contentButton {
  width: var(--button-width);
  height: 100%;
  line-height: 38px; // This matches toolbar's extension default height
  vertical-align: middle;
  margin-left: 36px; // 52px (icon width) - 16px (toolbar content padding)
  padding: 0px;
  text-align: center;
}
.bg-with-transparency {
  background-color: rgb(255, 255, 255, 0) !important;
  width: 100vw;
}
.subtitle-sheet {
  background-color: rgb(255, 255, 255, 0);
  font-weight: bold;
}
.subheading {
  margin-bottom: 15px;
  max-width: 78vw;
  word-wrap: break-word;
  line-height: 22px;
  padding-bottom: 15px;
  font-weight: bold;
  font-size: 1.1rem;
}
.v-toolbar__content {
  height: 10px;
  width: 100%;
}
</style>
